import React from 'react'
import TranslationDate from '../../Translation/cont/TranslationDate'
import Translation from '../../Translation/cont/Translation'


export const AdvertisementTextSpan = ({children, extraClass = false}) => (
    <span className={extraClass ? "title-large-light " + extraClass : "title-large-light"}>{children}</span>
)

export const AdvertisementValue = ({value, type = 'text', extraClass = false})  => (
    <AdvertisementTextSpan extraClass={extraClass}>
        {'check' === type ? (
            <span className={'check-indicator ' + (value ? 'has-content' : 'has-no-content')}/>
        ) : 'date'  === type ? (
            value && <TranslationDate string={value} hasYear={true} />
        ) : (
            value
        )}
    </AdvertisementTextSpan>
)

export const AdvertisementsCinemasList = ({cliCinemasIdList, cliCinemas, cinemasFilter}) => {
    // ToDO: Wann nicht anzeigen?
    if(!cliCinemas) {
        return ''
    }

    return (
        <div className="adverisement-container-cinemas">
            {cliCinemasIdList.map((cinemaId, index) => {
                const cinema = cliCinemas[cinemaId]
                const activeClass = cinemasFilter.includes(cinemaId) ? 'active' : 'not-active'

                return (
                    <div className={"cinema-item text-small-light " + activeClass} key={cinemaId}>
                         {cinema.nameShort}
                    </div>
                )
            })}
        </div>
    )
}

export const AdvertisementListNoticeMulticinema = ({maxItems, trueMaxItems}) => {
    if(false === maxItems) {
        return ''
    }

    return (
        <div className="advertisement-notice text-small-light">
            <Translation id="advertisement_only_max" /> {maxItems} {maxItems !== trueMaxItems ? <Translation id="advertisement_explanation_weischer"/> : <Translation id="advertisement_explanation_multicinema" />}
        </div>

    )
}


export const AdvertisementListNoticeSingleCinema = ({maxItems, trueMaxItems}) => (
    <div className="advertisement-notice text-small-light">
        {maxItems !== trueMaxItems && <Translation id="advertisement_explanation_space_used" after=" " />}
        
        {1 === trueMaxItems ? (
            <Translation id="advertisement_only_one" after=" " />
        ) : (
            <>
                <Translation id="advertisement_only_max" /> {trueMaxItems} <Translation id="advertisement_explanation_cinemas" after=" " />
            </>
            
        )} 
        
        <Translation id="advertisement_explanation_not_used" />
    </div>
)


